import { z } from 'zod';

import type { Database } from '../../../lib/database.types';

const optionalEmail = z
  .string()
  .trim()
  .optional()
  .refine((value) => !value || z.string().email().safeParse(value).success, 'אימייל לא תקין');

const optionalUrl = z
  .string()
  .trim()
  .optional()
  .refine((value) => {
    if (!value) return true;
    try {
      const url = new URL(value);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch {
      return false;
    }
  }, 'כתובת לא תקינה');

export const contactSchema = z.object({
  full_name: z.string().trim().min(1, 'שדה חובה').max(120, 'עד 120 תווים'),
  role_title: z.string().trim().max(80, 'עד 80 תווים').optional(),
  email: optionalEmail,
  phone: z.string().trim().optional(),
  linkedin_url: optionalUrl,
  notes: z.string().trim().max(2000, 'עד 2000 תווים').optional(),
});

export type ContactInput = z.infer<typeof contactSchema>;

type ContactTableRow = Database['public']['Tables']['contacts']['Row'];

export type CompanyContactRow = Pick<
  ContactTableRow,
  | 'id'
  | 'full_name'
  | 'role_title'
  | 'email'
  | 'phone'
  | 'linkedin_url'
  | 'notes'
  | 'company_id'
  | 'created_at'
  | 'updated_at'
>;
